var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.81389 10.7369V19.3265C3.81389 19.6307 3.711 19.8857 3.50521 20.0915C3.29941 20.2973 3.04441 20.4002 2.7402 20.4002C2.43598 20.4002 2.18098 20.2973 1.97519 20.0915C1.7694 19.8857 1.6665 19.6307 1.6665 19.3265V1.07369C1.6665 0.769481 1.7694 0.514479 1.97519 0.308687C2.18098 0.102896 2.43598 0 2.7402 0H17.2619C17.4588 0 17.6332 0.0447373 17.7853 0.134212C17.9374 0.223686 18.0582 0.340003 18.1477 0.483163C18.2372 0.626322 18.2953 0.782902 18.3222 0.952904C18.349 1.12291 18.3267 1.29738 18.2551 1.47633L16.6982 5.36847L18.2551 9.26061C18.3267 9.43956 18.349 9.61404 18.3222 9.78404C18.2953 9.95404 18.2372 10.1106 18.1477 10.2538C18.0582 10.3969 17.9374 10.5133 17.7853 10.6027C17.6332 10.6922 17.4588 10.7369 17.2619 10.7369H3.81389ZM3.81389 8.58956H15.6782L14.7119 6.17374C14.6045 5.92321 14.5508 5.65479 14.5508 5.36847C14.5508 5.08215 14.6045 4.81373 14.7119 4.5632L15.6782 2.14739H3.81389V8.58956Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.bff6b126ac7d2d89f68ce45e85d15755.svg";
export { ForwardRef as ReactComponent };